import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './v-ciso-services.css'

const VCISOServices = (props) => {
  return (
    <div className="vciso-services-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="vCISO-Services - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/v-ciso-services"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="vciso-services-hero-section">
        <video
          src="https://videos.pexels.com/video-files/4474931/4474931-hd_1920_1080_30fps.mp4"
          loop="true"
          muted="true"
          autoPlay="true"
          playsInline="true"
          className="hero-video"
        ></video>
        <div className="hero-overlay"></div>
        <div className="vciso-services-hero-content">
          <h1 className="hero-title">
            Executive Security Leadership On Demand
          </h1>
          <p className="hero-subtitle">
            Strategic vCISO services delivering enterprise-grade cybersecurity
            leadership, governance, and risk management without the overhead of
            full-time executive hiring
          </p>
          <div className="vciso-services-hero-cta-group hero-cta-group">
            <a href="#contact">
              <div className="btn-primary btn btn-lg">
                <span>Schedule Assessment</span>
              </div>
            </a>
            <a href="#services">
              <div className="btn btn-lg btn-outline">
                <span style={{ color: 'black' }}>Explore Services</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="challenges-section">
        <div className="challenges-container">
          <div className="challenges-header">
            <h2 className="section-title">The Executive Security Gap</h2>
            <p className="section-subtitle">
              Organizations face unprecedented cybersecurity challenges that
              demand strategic leadership
            </p>
          </div>
          <div className="challenges-grid">
            <div className="challenges-card">
              <div className="challenges-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="challenges-card-title">Risk Management Gaps</h3>
              <p className="challenges-card-text">
                Critical vulnerabilities remain unaddressed without dedicated
                security leadership to identify, prioritize, and mitigate
                organizational risks across the enterprise landscape.
              </p>
            </div>
            <div className="challenges-card">
              <div className="challenges-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="challenges-card-title">Regulatory Pressure</h3>
              <p className="challenges-card-text">
                Evolving compliance requirements from ISO, SOC, PCI-DSS, GDPR,
                and emerging AI regulations demand expert guidance to navigate
                complex frameworks and avoid penalties.
              </p>
            </div>
            <div className="challenges-card">
              <div className="challenges-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="challenges-card-title">Strategic Direction</h3>
              <p className="challenges-card-text">
                Security initiatives lack alignment with business objectives,
                resulting in inefficient spending, technological debt, and
                inadequate protection against sophisticated threats.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="vciso-services-services-section">
        <div className="services-container">
          <div className="vciso-services-services-header services-header">
            <h2 className="section-title">Comprehensive vCISO Services</h2>
            <p className="section-subtitle">
              End-to-end strategic security leadership tailored to your
              organization&apos;s maturity and risk profile
            </p>
          </div>
          <div className="services-process">
            <div className="services-step">
              <div className="services-step-number">
                <span>01</span>
              </div>
              <div className="services-step-content">
                <h3 className="services-step-title">
                  Strategic Security Leadership
                </h3>
                <p className="services-step-text">
                  Executive-level guidance that aligns cybersecurity initiatives
                  with business objectives, board reporting, and stakeholder
                  communication. Define security vision, establish governance
                  committees, and drive organizational culture change.
                </p>
              </div>
            </div>
            <div className="services-step">
              <div className="services-step-number">
                <span>02</span>
              </div>
              <div className="services-step-content">
                <h3 className="services-step-title">
                  Comprehensive Risk Assessment
                </h3>
                <p className="services-step-text">
                  Systematic evaluation of organizational threats,
                  vulnerabilities, and business impact. Quantitative and
                  qualitative risk analysis, threat modeling, asset inventory,
                  and control effectiveness assessment across all domains.
                </p>
              </div>
            </div>
            <div className="services-step">
              <div className="services-step-number">
                <span>03</span>
              </div>
              <div className="services-step-content">
                <h3 className="services-step-title">
                  Policy Development &amp; Governance
                </h3>
                <p className="services-step-text">
                  Creation of enterprise security policies, standards, and
                  procedures aligned with industry frameworks. Establish
                  information security management systems, data classification
                  schemes, and acceptable use policies.
                </p>
              </div>
            </div>
            <div className="services-step">
              <div className="services-step-number">
                <span>04</span>
              </div>
              <div className="services-step-content">
                <h3 className="services-step-title">
                  Governance Framework Implementation
                </h3>
                <p className="services-step-text">
                  Deploy NIST, ISO 27001, CIS Controls, or custom frameworks
                  tailored to organizational needs. Implement security metrics
                  dashboards, KPIs, and continuous monitoring programs for
                  sustained compliance.
                </p>
              </div>
            </div>
            <div className="services-step">
              <div className="services-step-number">
                <span>05</span>
              </div>
              <div className="services-step-content">
                <h3 className="services-step-title">
                  Security Roadmap &amp; Budget Planning
                </h3>
                <p className="services-step-text">
                  Multi-year strategic roadmap prioritizing initiatives by risk
                  reduction and business value. Technology stack optimization,
                  vendor selection guidance, and budget justification for
                  executive approval.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="artifacts-section">
        <div className="artifacts-container">
          <div className="artifacts-header">
            <h2 className="section-title">Tangible Deliverables</h2>
            <p className="section-subtitle">
              Concrete documentation and frameworks you can implement
              immediately
            </p>
          </div>
          <div className="artifacts-grid">
            <div className="artifacts-card">
              <div className="artifacts-image-wrapper">
                <img
                  alt="Man in formal attire reviewing paperwork, holding glasses. Business setting."
                  src="https://images.pexels.com/photos/7534805/pexels-photo-7534805.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  loading="lazy"
                  className="artifacts-image"
                />
                <div className="artifacts-overlay"></div>
              </div>
              <div className="artifacts-content">
                <h3 className="artifacts-card-title">Risk Registers</h3>
                <p className="artifacts-card-text">
                  Comprehensive risk matrices with threat assessments,
                  likelihood ratings, business impact analysis, and mitigation
                  strategies.
                </p>
              </div>
            </div>
            <div className="artifacts-card">
              <div className="artifacts-image-wrapper">
                <img
                  alt="Two professionals in a high-tech environment working with cash and computers, analyzing complex data."
                  src="https://images.pexels.com/photos/6266446/pexels-photo-6266446.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  loading="lazy"
                  className="artifacts-image"
                />
                <div className="artifacts-overlay"></div>
              </div>
              <div className="artifacts-content">
                <h3 className="artifacts-card-title">Security Strategy</h3>
                <p className="artifacts-card-text">
                  Multi-year strategic plan aligned with business objectives,
                  including technology roadmap and investment priorities.
                </p>
              </div>
            </div>
            <div className="artifacts-card">
              <div className="artifacts-image-wrapper">
                <img
                  alt="Two professionals in a secure office setting discussing confidential documents over coffee."
                  src="https://images.pexels.com/photos/6069486/pexels-photo-6069486.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  loading="lazy"
                  className="artifacts-image"
                />
                <div className="artifacts-overlay"></div>
              </div>
              <div className="artifacts-content">
                <h3 className="artifacts-card-title">
                  Security Metrics Dashboard
                </h3>
                <p className="artifacts-card-text">
                  Executive KPI dashboards tracking security posture, incident
                  trends, compliance status, and program maturity.
                </p>
              </div>
            </div>
            <div className="artifacts-card">
              <div className="artifacts-image-wrapper">
                <img
                  alt="A man in a white shirt thinking, seated at a desk with papers and a plant."
                  src="https://images.pexels.com/photos/7534759/pexels-photo-7534759.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  loading="lazy"
                  className="artifacts-image"
                />
                <div className="artifacts-overlay"></div>
              </div>
              <div className="artifacts-content">
                <h3 className="artifacts-card-title">
                  Implementation Roadmaps
                </h3>
                <p className="artifacts-card-text">
                  Phased deployment plans with timelines, resource requirements,
                  dependencies, and success criteria.
                </p>
              </div>
            </div>
            <div className="artifacts-card">
              <div className="artifacts-image-wrapper">
                <img
                  alt="A detective examines photographs and evidence in an office setting, focusing on a case."
                  src="https://images.pexels.com/photos/6069239/pexels-photo-6069239.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  loading="lazy"
                  className="artifacts-image"
                />
                <div className="artifacts-overlay"></div>
              </div>
              <div className="artifacts-content">
                <h3 className="artifacts-card-title">Policy Documentation</h3>
                <p className="artifacts-card-text">
                  Enterprise security policies, standards, and procedures ready
                  for organizational deployment and compliance audits.
                </p>
              </div>
            </div>
            <div className="artifacts-card">
              <div className="artifacts-image-wrapper">
                <img
                  alt="Top view of a planner with wooden tiles spelling 'health insurance' and scattered pills."
                  src="https://images.pexels.com/photos/7163949/pexels-photo-7163949.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  loading="lazy"
                  className="artifacts-image"
                />
                <div className="artifacts-overlay"></div>
              </div>
              <div className="artifacts-content">
                <h3 className="artifacts-card-title">Governance Reports</h3>
                <p className="artifacts-card-text">
                  Board-ready presentations and executive summaries
                  communicating security posture and strategic recommendations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="compliance-section">
        <div className="compliance-container">
          <div className="compliance-header">
            <h2 className="section-title">Framework Alignment</h2>
            <p className="section-subtitle">
              Our vCISO services map directly to industry-leading standards and
              regulatory requirements
            </p>
          </div>
          <div className="compliance-grid">
            <div className="compliance-card">
              <div className="compliance-icon">
                <svg
                  width="56"
                  xmlns="http://www.w3.org/2000/svg"
                  height="56"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-card-title">ISO 27001</h3>
              <p className="compliance-card-text">
                Information Security Management System implementation and
                certification readiness
              </p>
            </div>
            <div className="compliance-card">
              <div className="compliance-icon">
                <svg
                  width="56"
                  xmlns="http://www.w3.org/2000/svg"
                  height="56"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="compliance-card-title">SOC 2 Type II</h3>
              <p className="compliance-card-text">
                Trust service criteria compliance for security, availability,
                and confidentiality controls
              </p>
            </div>
            <div className="compliance-card">
              <div className="compliance-icon">
                <svg
                  width="56"
                  xmlns="http://www.w3.org/2000/svg"
                  height="56"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8 9V2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="compliance-card-title">PCI-DSS v4.0</h3>
              <p className="compliance-card-text">
                Payment card industry data security standard compliance for
                cardholder environments
              </p>
            </div>
            <div className="compliance-card">
              <div className="compliance-icon">
                <svg
                  width="56"
                  xmlns="http://www.w3.org/2000/svg"
                  height="56"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="M6.376 18.91a6 6 0 0 1 11.249.003"></path>
                    <circle r="4" cx="12" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="compliance-card-title">AI GRC</h3>
              <p className="compliance-card-text">
                Artificial intelligence governance, risk management, and
                compliance frameworks
              </p>
            </div>
            <div className="compliance-card">
              <div className="compliance-icon">
                <svg
                  width="56"
                  xmlns="http://www.w3.org/2000/svg"
                  height="56"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zM9 12h6m-3-3v6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="compliance-card-title">NIST CSF 2.0</h3>
              <p className="compliance-card-text">
                Cybersecurity framework alignment for identify, protect, detect,
                respond, and recover functions
              </p>
            </div>
            <div className="compliance-card">
              <div className="compliance-icon">
                <svg
                  width="56"
                  xmlns="http://www.w3.org/2000/svg"
                  height="56"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zM9 12h6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="compliance-card-title">GDPR &amp; CCPA</h3>
              <p className="compliance-card-text">
                Data privacy compliance for European and California consumer
                protection regulations
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="vciso-services-thq-cta-section-elm vciso-services-cta-section">
        <div className="vciso-services-thq-cta-content-wrapper-elm cta-content-wrapper">
          <div className="vciso-services-cta-content-left">
            <h2 className="section-title">
              Ready to Elevate Your Security Leadership?
            </h2>
            <p className="section-content">
              Schedule a confidential assessment with our vCISO team to discuss
              your organization&apos;s strategic security needs, compliance
              requirements, and governance maturity. We&apos;ll develop a
              tailored engagement plan that delivers immediate value.
            </p>
            <ul className="vciso-services-cta-benefits-list">
              <li className="vciso-services-cta-benefit-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
                <span>No long-term commitments required</span>
              </li>
              <li className="vciso-services-cta-benefit-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
                <span>Flexible engagement models for any budget</span>
              </li>
              <li className="vciso-services-cta-benefit-item">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
                <span>Proven track record across industries</span>
              </li>
              <li className="vciso-services-cta-benefit-item"></li>
            </ul>
          </div>
          <div className="vciso-services-cta-content-right">
            <div className="vciso-services-thq-cta-card-elm cta-card">
              <h3 className="cta-card-title">Schedule Your Assessment</h3>
              <p className="cta-card-text">
                Connect with a senior vCISO consultant to discuss your strategic
                security needs.
              </p>
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Book Consultation</span>
                </div>
              </a>
              <p className="cta-contact-text">Email: ciso@cysigil.com</p>
            </div>
          </div>
        </div>
      </section>
      <div className="vciso-services-container2">
        <div className="vciso-services-container3">
          <Script
            html={`<script defer data-name="video-autoplay">
(function(){
  const heroVideo = document.querySelector(".hero-video")
  if (heroVideo) {
    heroVideo.play().catch(() => {
      heroVideo.muted = true
      heroVideo.play()
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default VCISOServices
